import { createContext } from "react";
const MultiSelectActionsContext = createContext({
  onChange: () => {
  },
  onClose: () => {
  },
  multi: !0
}), MultiSelectContext = createContext({
  multi: !0
});
export {
  MultiSelectActionsContext,
  MultiSelectContext
};
//# sourceMappingURL=MultiSelectContext.js.map
